import React, {useState, useEffect} from 'react';
import {
    CircularProgress,
    Paper,
    Typography,
} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import useStyles from '../styles/styles';
import {useQuery} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';
import getEnvironment from "../utils/getEnvironment";
import CampaignFilterListControl from "../components/CampaignFilterList/CampaignFilterListControl"

const CampaignFilterLists = () => {
    const classes = useStyles();

    const prodBucketName = 'campaign-filter-list-prod';
    const testBucketName = 'campaign-filter-list-test';
    const getBucketName = () => {
        return (getEnvironment() == 'prod') ? prodBucketName : testBucketName;
    }

    const {loading, error, data} = useQuery(gql`
        query allCampaignFilterList($bucketName: String!) {
            getPresignedUrl(bucketName: $bucketName) {
                url
                bucketName
                keyName
            }
            campaignFilterListMutationMaxRecords
            allFilterFields: __type(name: "FilterFields") {
                enumValues {
                    name
                }
            }
        }
    `, {
        variables: {
            bucketName: getBucketName()
        }
    });

    return (
        <>
            <Typography variant="h2" style={{ marginBottom: '10px' }}>
                Campaign Filter Lists
            </Typography>
            {!loading && error ? (
                <Paper className={classes.paper}>
                    <Alert severity="error">There is an error!</Alert>
                    <pre>{JSON.stringify(error, null, 2)}</pre>
                </Paper>
            ) : null}
            {loading ? (
                <Paper className={classes.paper}>
                    <div className={classes.loadingBar}>
                        <CircularProgress
                            size={50}
                            thickness={4}
                        />
                    </div>
                </Paper>
            ) : null}
            {!loading
                && data
                && data.allFilterFields.enumValues
                && data.campaignFilterListMutationMaxRecords
                && data.getPresignedUrl ? (
                <CampaignFilterListControl
                    data={data}
                />
            ) : null}
        </>
    );
};

export default CampaignFilterLists;
